import React, { useEffect } from "react";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import LockOutlined from "@material-ui/icons/LockOutlined";
import PeopleOutlined from "@material-ui/icons/PeopleOutlined";
import PhoneIphone from "@material-ui/icons/PhoneIphone";
import DateRangeOutlined from "@material-ui/icons/DateRangeOutlined";
import formStyles from "../formStyles";
import { getCurrentLocale } from "../helpers/getCurrentLocale";
import { useTranslation } from "react-i18next";
import LanguageDropdown from "../components/languageDropdown";
import LOGO from "../images/Telkey_logo_white.png";

const ICON_STYLE = { fontSize: 28 };

const HERO_ITEMS = [
  { icon: <LockOutlined style={ICON_STYLE} />, key: "hero.locks" },
  { icon: <PeopleOutlined style={ICON_STYLE} />, key: "hero.users" },
  { icon: <PhoneIphone style={ICON_STYLE} />, key: "hero.app" },
  { icon: <DateRangeOutlined style={ICON_STYLE} />, key: "hero.bookings" },
];

export default function MainLayout(props) {
  const { i18n, t } = useTranslation();

  useEffect(() => {
    const currentLocale = getCurrentLocale();
    i18n.changeLanguage(currentLocale);
  }, []);

  const classes = formStyles();

  return (
    <Grid container component="main" className={classes.root}>
      <Grid
        item
        xs={12}
        sm={8}
        md={5}
        lg={4}
        xl={3}
        component={Paper}
        elevation={6}
        square
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            backgroundColor: "#222729",
            padding: "10px 20px",
          }}
        >
          <img src={LOGO} height={32} alt="Telkey" />
          <LanguageDropdown />
        </div>
        <div className={classes.paper}>{props.children}</div>
      </Grid>
      <Grid
        item
        xs={false}
        sm={4}
        md={7}
        lg={8}
        xl={9}
        className={classes.image}
      >
        <div style={{ padding: "80px 80px" }}>
          <div
            style={{
              backgroundColor: "rgba(0,0,0,0.35)",
              borderRadius: 20,
              padding: "32px 32px 16px 32px",
              display: "inline-block",
            }}
          >
            <Typography
              variant="h2"
              style={{
                color: "#fff",
                fontWeight: 700,
                lineHeight: 1.2,
                marginBottom: 0,
              }}
            >
              {t("hero.heading1")}
            </Typography>
            <Typography
              variant="h2"
              style={{
                color: "#fff",
                fontWeight: 700,
                lineHeight: 1.2,
                marginBottom: 16,
              }}
            >
              {t("hero.heading2")}
            </Typography>
            <Typography
              variant="h6"
              style={{
                color: "#fff",
                fontWeight: 300,
                marginBottom: 32,
              }}
            >
              {t("hero.subtitle")}
            </Typography>
            {HERO_ITEMS.map((item) => (
              <div
                key={item.key}
                style={{
                  display: "flex",
                  alignItems: "center",
                  padding: "10px 0",
                }}
              >
                <div
                  style={{
                    backgroundColor: "rgba(0,0,0,0.45)",
                    borderRadius: 10,
                    padding: 10,
                    marginRight: 18,
                    color: "#42de80",
                    display: "flex",
                  }}
                >
                  {item.icon}
                </div>
                <Typography
                  variant="h6"
                  style={{
                    color: "#fff",
                    fontWeight: 400,
                  }}
                >
                  {t(item.key)}
                </Typography>
              </div>
            ))}
          </div>
        </div>
      </Grid>
    </Grid>
  );
}
